// Global fetch interceptor — injects Authorization header and handles 401
const originalFetch = window.fetch;

window.fetch = async function (...args) {
  let [url, options = {}] = args;

  // Add auth header if token exists and it's an API call
  const token = localStorage.getItem('token');
  if (token && (typeof url === 'string') && url.startsWith('/api')) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    };
  }

  const response = await originalFetch(url, options);

  // Redirect to login on 401
  if (response.status === 401 && (typeof url === 'string') && url.startsWith('/api') && !url.includes('/auth/')) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  }

  return response;
};
